export default "/assets/Icon/Logo-Magic.svg"